// import JSEncrypt from 'jsencrypt';

export default {
  methods: {
    filterEmptyField(options = {}, emptyValues = ['', 0, null, [], {}, 'null']) {
      const oldData = JSON.parse(JSON.stringify(options));
      const newData = JSON.parse(JSON.stringify(options));
      Object.keys(oldData).forEach((key) => {
        if (emptyValues.some((emptyValue) => JSON.stringify(emptyValue) === JSON.stringify(oldData[key]))) {
          delete newData[key];
        }
      });
      return newData;
    },
  },
};
